module.exports = __webpack_public_path__ + "img/ZIP.005c4cb3.png";